
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"14","viewBox":"0 0 19 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"y":"6","width":"19","height":"2","rx":"1","fill":"white"}}),_c('path',{attrs:{"d":"M12.2854 2.65367L16.3894 7L12.2855 11.3463C11.9062 11.7234 11.9048 12.3361 12.2823 12.7149C12.6598 13.0938 13.2733 13.0951 13.6526 12.7182L18.7163 7.68502C19.0958 7.30673 19.0937 6.6911 18.7154 6.31406L13.6525 1.2818C13.2732 0.904819 12.6597 0.906222 12.2822 1.28509C11.9047 1.66392 11.9061 2.27664 12.2854 2.65367Z","fill":"white"}})])
          )
        }
      }
    